var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8748 7.41667C21.6209 3 17.113 0 12.0209 0C6.88696 0 2.37913 3 0.125217 7.41667C0.0417391 7.58333 0 7.79167 0 8C0 8.25 0.0417391 8.45833 0.125217 8.625C2.37913 13.0417 6.88696 16 12.0209 16C17.113 16 21.6209 13.0417 23.8748 8.625C23.9583 8.45833 24 8.25 24 8.04167C24 7.79167 23.9583 7.58333 23.8748 7.41667ZM12.0209 14C8.68174 14 6.01043 11.3333 6.01043 8C6.01043 4.70833 8.68174 2 12.0209 2C15.3183 2 18.0313 4.70833 18.0313 8V8.04167C18.0313 11.3333 15.3183 14.0417 12.0209 14.0417V14ZM12.0209 4C11.6452 4.04167 11.2696 4.08333 10.9357 4.16667C11.1861 4.5 11.3113 4.91667 11.3113 5.375C11.3113 6.45833 10.4348 7.33333 9.34957 7.33333C8.89043 7.33333 8.47304 7.20833 8.13913 6.95833C8.05565 7.29167 8.01391 7.66667 8.01391 8C8.01391 10.2083 9.8087 12 12.0209 12C14.233 12 16.0278 10.2083 16.0278 8C16.0278 5.79167 14.233 4.04167 12.0209 4.04167V4Z",
    fill: "#656565"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.cdbe5a1325f6ba55674fdbea8a11d3d5.svg";
export { ForwardRef as ReactComponent };